import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { ButtonEx, FlexRow } from '../components';
const toAxiosError = (error) => {
    return error.isAxiosError ? error : undefined;
};
const ErrorDialogOpen = (props) => {
    var _a, _b;
    const { onClose, title = 'Oops. Something went wrong.', error = Error('Unknown Error') } = props;
    const onCloseClicked = () => {
        onClose === null || onClose === void 0 ? void 0 : onClose(false);
    };
    const onRetryClicked = () => {
        onClose === null || onClose === void 0 ? void 0 : onClose(true);
    };
    const axiosError = toAxiosError(error);
    const message = (_a = error.message) !== null && _a !== void 0 ? _a : error.toString();
    return (_jsxs(Dialog, Object.assign({ onClose: onClose, open: !!error }, { children: [_jsx(DialogTitle, { children: title }, void 0), _jsx(DialogContent, { children: _jsx(FlexRow, { children: _jsx(Typography, Object.assign({ color: "error" }, { children: axiosError ? `${message} [${(_b = axiosError === null || axiosError === void 0 ? void 0 : axiosError.code) !== null && _b !== void 0 ? _b : 'Connection Failure'}]` : `${message}` }), void 0) }, void 0) }, void 0), _jsx(DialogActions, { children: _jsxs(FlexRow, Object.assign({ justifyContent: "space-between", width: "100%", minWidth: "300px" }, { children: [_jsx(ButtonEx, Object.assign({ onClick: onCloseClicked, variant: "text" }, { children: "Close" }), void 0), _jsx(ButtonEx, Object.assign({ onClick: onRetryClicked, variant: "text" }, { children: "Retry" }), void 0)] }), void 0) }, void 0)] }), void 0));
};
const ErrorDialog = (props) => {
    const { error } = props;
    if (error) {
        return _jsx(ErrorDialogOpen, Object.assign({}, props), void 0);
    }
    else {
        return null;
    }
};
export default ErrorDialog;
//# sourceMappingURL=ErrorDialog.js.map